// 画面遷移時のスクロール制御
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ChildShelf } from './types/Template';

interface Props {
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
}

const ScrollTop: React.FC<Props> = ({ setChildShelfs }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    // 棚を全て初期状態（閉じた状態）に変更
    setChildShelfs(prev => {
      return prev.map(child_shelf => {
        return { ...child_shelf, cb_open: false };
      });
    });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default ScrollTop;
